import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    routerViewKey: "",
    breadcrumb: []
  },
  getters: {
    getRouterViewKey (state) {
      return state.routerViewKey
    }
  },
  mutations: {
    setRouterViewKey (state, viewKey) {
      state.routerViewKey = viewKey
    },
    setBreadcrumb(state, breadcrumb) {
      state.breadcrumb = breadcrumb;
    }
  },
  actions: {
    updateRouterViewKey({ commit }, viewKey) {
      commit("setRouterViewKey", viewKey);
    },
    updateBreadcrumb({ commit }, breadcrumb) {
      commit("setBreadcrumb", breadcrumb);
    }
  },
  modules: {
  }
})
